import React from "react";

/**
 * ErrorBoundary
 *
 * React render/lifecycle sırasında fırlatılan hataları yakalar ve tüm
 * uygulamanın "beyaz ekrana" düşmesini engeller. Hata olursa kurumsal kimliğe
 * uygun bir "bir şeyler ters gitti" arayüzü gösterir; kullanıcı sayfada kalır,
 * "Tekrar Dene" ile içerik yeniden render edilir.
 *
 * Not: Class component olmak ZORUNDA — error boundary'ler yalnızca
 * getDerivedStateFromError / componentDidCatch ile (hook'larla DEĞİL) yazılabilir.
 *
 * Props:
 *   - resetKey: değeri değiştiğinde boundary otomatik sıfırlanır (örn. route yolu).
 *               Böylece başka bir sayfaya geçildiğinde eski hata ekranı kalmaz.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Geliştirme/teşhis için konsola yaz; uygulama çökmeden devam eder.
    // İstenirse buradan bir hata izleme servisine (Sentry vb.) gönderilebilir.
    console.error("ErrorBoundary yakaladı:", error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    // Route (veya verilen anahtar) değişince hatalı durumdan otomatik çık.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const NAVY = "#221c5d";
    const ORANGE = "#e56a22";

    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
        }}
      >
        <div
          style={{
            maxWidth: 460,
            width: "100%",
            textAlign: "center",
            background: "#fff",
            border: "1px solid #e9edf5",
            borderRadius: 24,
            boxShadow: "0 1.25rem 2.5rem rgba(34,28,93,0.10)",
            padding: "2.5rem 2rem",
          }}
        >
          <div
            style={{
              width: 72,
              height: 72,
              margin: "0 auto 1.25rem",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(229,106,34,0.12)",
            }}
          >
            <i
              className="bx bx-error-circle"
              style={{ fontSize: 38, color: ORANGE }}
            />
          </div>

          <h5 style={{ fontWeight: 700, color: NAVY, marginBottom: ".6rem" }}>
            Bir şeyler ters gitti
          </h5>
          <p style={{ color: "#64748b", fontSize: ".95rem", marginBottom: "1.75rem" }}>
            Bu bölüm geçici olarak görüntülenemedi. Sayfanın diğer kısımları
            çalışmaya devam ediyor. Lütfen tekrar deneyin.
          </p>

          <div style={{ display: "flex", gap: ".75rem", justifyContent: "center", flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={this.handleRetry}
              style={{
                background: NAVY,
                color: "#fff",
                border: "none",
                borderRadius: 999,
                padding: ".6rem 1.4rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <i className="bx bx-refresh me-1" /> Tekrar Dene
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                background: "transparent",
                color: NAVY,
                border: `1.5px solid ${NAVY}`,
                borderRadius: 999,
                padding: ".6rem 1.4rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Sayfayı Yenile
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
